/* norgira-mobile-logo-scroll-top */
(() => {
  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const footerLogo = event.target.closest('[data-norgira-scroll-top]');
    if (footerLogo) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const headerLogo = event.target.closest('#header-component .header-logo, #header-component .header-logo a');
    if (!headerLogo) return;
    event.preventDefault();
    const home = new URL('/', window.location.origin);
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme) home.searchParams.set('preview_theme_id', previewTheme);
    if (window.location.pathname === '/' || window.location.pathname === '/index') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.assign(home.toString());
    }
  }, true);
})();
/* end norgira-mobile-logo-scroll-top */
